import { Fragment } from 'react';
import { MdPhoneInTalk } from 'react-icons/md';
import { CS_PROCTOR_SHADOW_TITLE, CS_CERTIFICATE_TYPE, ORGAN_ICON } from '@/utils/helpers';
import { CSResource } from '@/api/apis/resources/schedule';
import { OrganType } from '@/api/apis/case';

type CSUserCellSubtitleProps = {
  user: CSResource;
};

export const CSUserCellSubtitle = ({ user }: CSUserCellSubtitleProps) => {
  const { canPhoneSupport, organs, phoneSupportOrgans, shadowOrgans, proctorOrgans } = user;

  const renderOrgans = (organList: OrganType[] | null) => {
    return Array.from(new Set(organList)).map((o) => {
      const OrganIcon = ORGAN_ICON[o] ?? Fragment;
      return <OrganIcon key={o} className="text-base-5 size-4" />;
    });
  };

  return (
    <div className="flex flex-wrap gap-1 items-center">
      {renderOrgans(organs)}
      {canPhoneSupport && (
        <div className="flex gap-0.5 items-center ms-1 px-0.5 bg-indigo-80 rounded-lg min-h-4">
          <MdPhoneInTalk className="text-indigo-20" size={14} />
          {renderOrgans(phoneSupportOrgans)}
        </div>
      )}
      {!!proctorOrgans.length && (
        <div className="flex gap-0.5 items-center ms-1 px-1 bg-base-70 rounded-lg min-h-4">
          <span className="text-xs-sb text-base-20">{CS_PROCTOR_SHADOW_TITLE[CS_CERTIFICATE_TYPE.PROCTOR]}</span>
          {renderOrgans(proctorOrgans)}
        </div>
      )}
      {!!shadowOrgans.length && (
        <div className="flex gap-0.5 items-center ms-1 px-1 bg-base-70 rounded-lg min-h-4">
          <span className="text-xs-sb text-base-20">{CS_PROCTOR_SHADOW_TITLE[CS_CERTIFICATE_TYPE.SHADOW]}</span>
          {renderOrgans(shadowOrgans)}
        </div>
      )}
    </div>
  );
};
